export default class TransportPrice {
  id: any;
  name: string;
  price: number;
  people_min: number;
  people_max: number;
  required: any;
  transport_id: any;
  group: any;
  suggest: any;
  daily_or_km: any; // Este campo es para gestionar daily y km solo en uno. Si a futuro se quieren guardar los dos, hay que cambiarlo.


  constructor() {
    this.id = null;
    this.name = '';
    this.price = 0;
    this.people_min = 0;
    this.people_max = 0;
    this.required = 0;
    this.transport_id = null;
    this.group = 0;
    this.suggest = 0;
    this.daily_or_km = null;
  }

  public static copy(model: any) {
    const aux = new TransportPrice();
    aux.id = model.id;
    aux.name = model.name;
    aux.price = model.price;
    aux.people_min = model.people_min;
    aux.people_max = model.people_max;
    aux.required = model.required;
    aux.transport_id = model.transport_id;
    aux.group = model.group;
    aux.suggest = model.suggest;
    aux.daily_or_km = model.daily_or_km;
    return aux;
  }
}
